import { defineStore } from 'pinia';

export const useWishlistSidebarStore = defineStore('wishlistSidebar', {
    state: () => ({
        sidebarOpen: false,
        // Add a refresh trigger
        refreshTrigger: 0,
        isRefreshing: false,
    }),
    actions: {
        invokeWishlistSidebar() {
            if (!this.sidebarOpen) {
                this.sidebarOpen = true;
            } else {
                this.sidebarOpen = false;
            }
        },
        // Add method to trigger wishlist refresh with debounce
        async triggerWishlistRefresh() {
            if (this.isRefreshing) {
                return;
            }

            this.isRefreshing = true;
            this.refreshTrigger++;

            // Reset the refreshing flag after a short delay
            setTimeout(() => {
                this.isRefreshing = false;
            }, 500);
        },
    },
});
